import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import PageTitle from "../components/PageTitle";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import { DndContext } from "@dnd-kit/core";
import { motion, AnimatePresence } from "framer-motion";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Image from "react-bootstrap/Image";
import { createTemplate, updateTemplate, getTemplateById } from "../services/templateService";
import { createReport, getReportById, updateReport } from "../services/reportService";
import { getConversationDetail, getChatFiles } from "../services/chatServices";
import { useAlert } from "../contexts/AlertContext";
import CardWrapper from "../layouts/CardWrapper";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Document, Page, Text, PDFDownloadLink, pdf, PDFViewer } from "@react-pdf/renderer";
import { useAtom } from 'jotai';
import { debounce } from "lodash";
import { disableQuickPreviewAtom } from '../states/reportEditStatus';

import {
  BuildingsIcon,
  ClockCountdownIcon,
  ImageIcon,
  LightningIcon,
  LinkIcon,
  NotePencilIcon,
  PlusIcon,
  SaveIcon,
  SignatureIcon,
  TextAaIcon,
  TextTIcon,
  UserCircleGearIcon,
  UserListIcon,
  XIcon,
} from "../components/SVGIcon";
import CompanySection from "./DigitalTemplateSection/CompanySection";
import TitleSection, { TitleSchema } from "./DigitalTemplateSection/TitleSection";
// import ClientDetailsSection, { ClientDetailSchema } from "./DigitalTemplateSection/ClientDetailsSection";
// import ExpertiseDetailsSection, { ExpertiseDetailsSchema } from "./DigitalTemplateSection/ExpertiseDetailsSection";
import PhotoSection, { PhotoSectionSchema } from "./DigitalTemplateSection/PhotoSection";
import NotesSection, { NotesSchema } from "./DigitalTemplateSection/NotesSection";
// import SessionDetailsSection, { SessionDetailsSchema } from "./DigitalTemplateSection/SessionDetailsSection";
import SignatureSection, { SignatureSchema } from "./DigitalTemplateSection/SignatureSection";
import AttachmentsSection, { AttachmentsSectionSchema } from "./DigitalTemplateSection/AttachmentsSection";
import { useParams } from "react-router-dom";
import ReportPreview from "./ReportPreview/ReportPreview";
import ReportPDF from "./ReportPreview/ReportPDF";

const schemaDefaultObjectField = {
  "id": null,
  "templateType": "field",
  "name": "",
  "images": [],
  "schema": [
    {
      "name": "Participant1 Details",
      "id": uuidv4(),
      "tag": "CompanyDetails",
      "fields": [
        {
          "type": "arrayOfImages",
          "selectedDropdownValue": "images",
          "name": "Company Logos",
          "value": [
            "",
            "",
            ""
          ]
        },
        {
          "type": "text",
          "label": "Company Name",
          "placeholder": "",
          "selectedDropdownValue": "companyName",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Address",
          "placeholder": "",
          "selectedDropdownValue": "address",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "City",
          "placeholder": "",
          "selectedDropdownValue": "city",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "State",
          "placeholder": "",
          "selectedDropdownValue": "state",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Country",
          "placeholder": "",
          "selectedDropdownValue": "country",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Zip Code",
          "placeholder": "zipCode",
          "selectedDropdownValue": "zipCode",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Participant 1 Name",
          "placeholder": "",
          "selectedDropdownValue": "name",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Email",
          "placeholder": "",
          "selectedDropdownValue": "email",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Phone",
          "placeholder": "",
          "selectedDropdownValue": "phoneNumber",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "name": "Title",
      "id": uuidv4(),
      "tag": "Title",
      "fields": [
        {
          "type": "text",
          "label": "Title",
          "placeholder": "Title",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        }
      ]
    },
    {
      "name": "Participant2 Details",
      "id": uuidv4(),
      "tag": "ClientDetails",
      "fields": [
        {
          "type": "text",
          "label": "Company",
          "placeholder": "Enter company name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Participant 2 Name",
          "placeholder": "Enter participant 2 name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Email",
          "placeholder": "Enter email address",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Phone",
          "placeholder": "Enter phone",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Address",
          "placeholder": "Enter address",
          "selectedDropdownValue": "address",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "City",
          "placeholder": "Enter city",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "State",
          "placeholder": "Enter state",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Country",
          "placeholder": "Enter country",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Zip Code",
          "placeholder": "Enter zip code",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Expertise Details",
      "tag": "ExpertiseDetails",
      "fields": [
        {
          "type": "text",
          "label": "Expertise",
          "placeholder": "Enter expertise name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Sub Expertise",
          "placeholder": "Enter sub expertise name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Photos",
      "tag": "Photos",
      "fields": [
        {
          "type": "arrayOfImages",
          "name": "Photos",
          "value": [
            {
              "url": "",
              "text": ""
            },
            {
              "url": "",
              "text": ""
            },
            {
              "url": "",
              "text": ""
            }
          ]
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Notes",
      "tag": "Notes",
      "fields": [
        {
          "type": "text",
          "label": "This section can be used to add any additional notes or comments related to the report.",
          "placeholder": "This section can be used to add any additional notes or comments related to the report.",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Session Details",
      "tag": "SessionDetails",
      "fields": [
        {
          "type": "text",
          "label": "Date",
          "placeholder": "Enter start date",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Duration",
          "placeholder": "Enter duration",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Start Time",
          "placeholder": "Enter start time",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "End Time",
          "placeholder": "Enter end time",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Participant 1",
          "placeholder": "Enter participant 1 name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        },
        {
          "type": "text",
          "label": "Participant 2",
          "placeholder": "Enter participant 2 name",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "field"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Signature",
      "tag": "Signature",
      "fields": [
        {
          "type": "expertSignature",
          "label": "Participant 1",
          "placeholder": "",
          "selectedDropdownValue": "admin.name",
          "value": "expert name",
          "isDigital": "digital"
        },
        {
          "type": "recipientSignature",
          "label": "Participant 2",
          "placeholder": "Enter participant 2 name",
          "selectedDropdownValue": "createdBy.name",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Attachments",
      "tag": "Attachments",
      "fields": [
        {
          "type": "ArrayOfAttachments",
          "name": "Attachments",
          "value": [
            "",
            "",
            "",
            ""
          ]
        }
      ]
    }
  ],
  "isActive": true,
  "isDeleted": false,
  "createdAt": "2025-09-17T13:43:58.946Z",
  "updatedAt": "2025-09-17T13:43:58.946Z"
};

const schemaDefaultObjectDigital = {
  "id": null,
  "templateType": "digital",
  "name": "",
  "images": [],
  "schema": [
    {
      "name": "Participant1 Details",
      "id": uuidv4(),
      "tag": "CompanyDetails",
      "fields": [
        {
          "type": "arrayOfImages",
          "name": "Company Logos",
          "selectedDropdownValue": "images",
          "value": [
            "",
            "",
            ""
          ]
        },
        {
          "type": "text",
          "label": "Company Name",
          "placeholder": "",
          "selectedDropdownValue": "admin.company",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Address",
          "placeholder": "",
          "selectedDropdownValue": "admin.address",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "City",
          "placeholder": "",
          "selectedDropdownValue": "admin.city",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "State",
          "placeholder": "",
          "selectedDropdownValue": "admin.state",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Country",
          "placeholder": "",
          "selectedDropdownValue": "admin.country",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Zip Code",
          "placeholder": "",
          "selectedDropdownValue": "admin.zipCode",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Participant 1 Name",
          "placeholder": "",
          "selectedDropdownValue": "admin.name",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Email",
          "placeholder": "",
          "selectedDropdownValue": "admin.email",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Phone",
          "placeholder": "",
          "selectedDropdownValue": "admin.phoneNumber",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "name": "Title",
      "id": uuidv4(),
      "tag": "Title",
      "fields": [
        {
          "type": "text",
          "label": "Title",
          "placeholder": "Title",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "name": "Participant2 Details",
      "id": uuidv4(),
      "tag": "CompanyDetails",
      "fields": [
        {
          "type": "text",
          "label": "Company",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.company",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Participant Name",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.name",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Email",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.email",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Phone",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.phoneNumber",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Address",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.address",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "City",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.city",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "State",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.state",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Country",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.country",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Zip Code",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.zipCode",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Expertise Details",
      "tag": "ExpertiseDetails",
      "fields": [
        {
          "type": "text",
          "label": "Expertise",
          "placeholder": "",
          "selectedDropdownValue": "expertiseName",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Sub Expertise",
          "placeholder": "",
          "selectedDropdownValue": "subExpertiseName",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Photos",
      "tag": "Photos",
      "fields": [
        {
          "type": "arrayOfImages",
          "name": "Photos",
          "value": [
            {
              "url": "",
              "text": ""
            },
            {
              "url": "",
              "text": ""
            },
            {
              "url": "",
              "text": ""
            }
          ]
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Notes",
      "tag": "Notes",
      "fields": [
        {
          "type": "text",
          "label": "This section can be used to add any additional notes or comments related to the report.",
          "placeholder": "This section can be used to add any additional notes or comments related to the report.",
          "selectedDropdownValue": "",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Session Details",
      "tag": "SessionDetails",
      "fields": [
        {
          "type": "text",
          "label": "Date",
          "placeholder": "",
          "selectedDropdownValue": "startDate",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Duration",
          "placeholder": "",
          "selectedDropdownValue": "duration",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Start Time",
          "placeholder": "",
          "selectedDropdownValue": "startTime",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "End Time",
          "placeholder": "",
          "selectedDropdownValue": "endTime",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Participant 1",
          "placeholder": "",
          "selectedDropdownValue": "admin.name",
          "value": "",
          "isDigital": "digital"
        },
        {
          "type": "text",
          "label": "Participant 2",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.name",
          "value": "",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Signature",
      "tag": "Signature",
      "fields": [
        {
          "type": "expertSignature",
          "label": "Participant 11",
          "placeholder": "",
          "selectedDropdownValue": "admin.name",
          "value": "expert name1",
          "isDigital": "digital"
        },
        {
          "type": "recipientSignature",
          "label": "Participant 22",
          "placeholder": "",
          "selectedDropdownValue": "createdBy.name",
          "value": "recipient name",
          "isDigital": "digital"
        }
      ]
    },
    {
      "id": uuidv4(),
      "name": "Attachments",
      "tag": "Attachments",
      "fields": [
        {
          "type": "ArrayOfAttachments",
          "name": "Attachments",
          "value": [
            "",
            "",
            "",
            ""
          ]
        }
      ]
    }
  ],
  "isActive": true,
  "isDeleted": false,
  "createdAt": "2025-09-17T13:43:58.946Z",
  "updatedAt": "2025-09-17T13:43:58.946Z"
};




function getDateTimeFormattedString(totalSeconds) {
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = String(Math.ceil(totalSeconds % 60)).padStart(2, '0');;

    const parts = [];

    if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
    if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? 's' : ''}`);
    if (minutes > 0) parts.push(`${minutes} min${minutes !== 1 ? 's' : ''}`);
    parts.push(`${seconds} sec${seconds !== 1 ? 's' : ''}`);

    return parts.join(', ');
  }

function populateTemplate(templateJson, conversationDetail, chatFiles) {

  const populatedTemplate = JSON.parse(JSON.stringify(templateJson)); // deep clone

  if (templateJson && (conversationDetail == null)) {

    const admin = conversationDetail?.admin || {};
    populatedTemplate.schema = populatedTemplate?.schema?.map((section) => {
      const updatedSection = { ...section };

      switch (section.tag) {
        // 1️⃣ Company Details
        case "CompanyDetails":
          updatedSection.fields = section.fields.map((field) => {
            console.log("11112222", field)
            const newField = { ...field };
            switch (field.selectedDropdownValue) {
              case "name":
                newField.value = admin?.companyName || "";
                break;
              case "images":
                newField.value = templateJson?.images || ["", "", ""];
                // alert("aaa");
                // console.log("caught")
                break;
              case "address":
                newField.value = admin?.address || "";
                break;
              case "city":
                newField.value = admin?.city || "";
                break;
              case "state":
                newField.value = admin?.state?.name || "";
                break;
              case "country":
                newField.value = admin?.country?.name || "";
                break;
              case "zipCode":
                newField.value = admin?.zipCode || "";
                break;
              case "email":
                newField.value = admin?.email || "";
                break;
              case "phoneNumber":
                newField.value = `+${admin?.countryCode || ""} ${admin?.phoneNo || ""}`.trim();
                break;
              default:
                if ((conversationDetail == null) && field.type === "arrayOfImages") {
                  console.log("Images found", field);
                }
                break;
            }
            return newField;
          });
          break;


      }

      return updatedSection;
    });

    console.log("jhere1", conversationDetail, populatedTemplate);
    return populatedTemplate;
  }

  if (!templateJson || !conversationDetail) return templateJson;
  console.log("before populate template", templateJson, conversationDetail, chatFiles)




  const admin = conversationDetail.admin || {};
  const createdBy = conversationDetail.createdBy || {};
  const expertise = conversationDetail.expertise || {};
  const conversationMembers = conversationDetail.conversationMembers || [];
  const startTime = conversationDetail.startTime ? new Date(conversationDetail.startTime) : null;
  const endTime = conversationDetail.endTime ? new Date(conversationDetail.endTime) : null;

  // Helper to find expert (member != createdBy)
  const expertMember = conversationMembers.find(
    (m) => m.userId !== createdBy.id
  );

  const formatDate = (date) =>
    date ? date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "";
  const formatTime = (date) =>
    date ? date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : "";
  const getDuration = (start, end) =>{
    const diffMs = Math.abs(end - start);
    const totalSeconds = Math.floor(diffMs / 1000) || 0;
    return getDateTimeFormattedString(totalSeconds);
  }
    

  // 🆕 Extract files from chatFiles
  const photoFiles = (chatFiles || []).filter(f => f.message_type === 3 && f.message);
  const attachmentFiles = (chatFiles || []).filter(f => f.message_type !== 3 && f.message);

  console.log("templateE", photoFiles, attachmentFiles)

  populatedTemplate.schema = populatedTemplate.schema.map((section) => {
    const updatedSection = { ...section };
    console.log("asdasdas111", section.tag)
    switch (section.tag) {
      // 1️⃣ Company Details
      case "CompanyDetails":
        updatedSection.fields = section.fields.map((field) => {
          const newField = { ...field };
          switch (field.selectedDropdownValue) {
            case "name":
              newField.value = admin.firstName + " " + admin.lastName || "";
              break;
            case "address":
              newField.value = admin.address || "";
              break;
            case "city":
              newField.value = admin.city || "";
              break;
            case "state":
              newField.value = admin?.state?.name || "";
              break;
            case "country":
              newField.value = admin?.country?.name || "";
              break;
            case "zipCode":
              newField.value = admin.zipCode || "";
              break;
            case "email":
              newField.value = admin.email || "";
              break;
            case "phoneNumber":
              newField.value = `+${admin.countryCode || ""} ${admin.phoneNo || ""}`.trim();
              break;
            case "admin.name":
              newField.value = admin.firstName + " " + admin.lastName || "";
              break;
            case "admin.company":
            newField.value = admin.companyName || "";
              break;
            case "admin.address":
              newField.value = admin.address || "";
              break;
            case "admin.city":
              newField.value = admin.city || "";
              break;
            case "admin.state":
              newField.value = admin?.state?.name || "";
              break;
            case "admin.country":
              newField.value = admin?.country?.name || "";
              break;
            case "admin.zipCode":
              newField.value = admin.zipCode || "";
              break;
            case "admin.email":
              newField.value = admin.email || "";
              break;
            case "admin.phoneNumber":
              newField.value = `${admin.countryCode || ""} ${admin.phoneNo || ""}`.trim();
              break;
            case "createdBy.name":
              newField.value = createdBy.firstName +" "+ createdBy.lastName || "";
              break;
            case "createdBy.company":
              newField.value = createdBy.companyName || "";
              break;
            case "createdBy.email":
              newField.value = createdBy?.email || "";
              break;
            case "createdBy.phoneNumber":
              newField.value = `${createdBy?.countryCode || ""} ${createdBy?.phoneNo || ""}`.trim();
              break;
            case "createdBy.address":
              newField.value = createdBy?.address || "";
              break;
            case "createdBy.city":
              newField.value = createdBy?.city || "";
              break;
            case "createdBy.state":
              newField.value = admin?.state?.name || "";
              break;
            case "createdBy.country":
              newField.value = createdBy?.country?.name || "";
              break;
            case "createdBy.zipCode":
              newField.value = createdBy?.zipCode || "";
              break;
            default:
              if ((conversationDetail == null) && field.type === "arrayOfImages") {
                console.log("Images found", field);
              }
              break;
          }
          return newField;
        });
        break;

      // 2️⃣ Client Details
      case "ClientDetails":
        updatedSection.fields = section.fields.map((field) => {
          const newField = { ...field };
          switch (field.selectedDropdownValue) {
            case "company":
              newField.value = createdBy.companyName || "";
              break;
            case "email":
              newField.value = createdBy?.email || "";
              break;
            case "phoneNumber":
              newField.value = `+${createdBy?.countryCode || ""} ${createdBy?.phoneNo || ""}`.trim();
              break;
            case "address":
              newField.value = createdBy?.address || "";
              break;
            case "city":
              newField.value = createdBy?.city || "";
              break;
            case "state":
              newField.value = admin?.state?.name || "";
              break;
            case "country":
              newField.value = createdBy?.country?.name || "";
              break;
            case "zipCode":
              newField.value = createdBy?.zipCode || "";
              break;
            default:
              break;
          }
          return newField;
        });
        break;

      // 3️⃣ Expertise Details
      case "ExpertiseDetails":
        updatedSection.fields = section.fields.map((field) => {
          const newField = { ...field };
          if (field.selectedDropdownValue === "expertiseName" || field.selectedDropdownValue === "subExpertiseName") {
            newField.value = expertise.name || "";
          }
          return newField;
        });
        break;

      // 4️⃣ Session Details
      case "SessionDetails":
        updatedSection.fields = section.fields.map((field) => {
          const newField = { ...field };
          switch (field.selectedDropdownValue) {
            case "startDate":
              newField.value = formatDate(startTime);
              break;
            case "duration":
              newField.value = getDuration(startTime, endTime);
              break;
            case "startTime":
              newField.value = formatTime(startTime);
              break;
            case "endTime":
              newField.value = formatTime(endTime);
              break;
            case "admin.name":
              newField.value = admin.firstName + " " + admin.lastName || "";
              break;
            case "createdBy.name":
              newField.value = createdBy.firstName +" "+ createdBy.lastName || "";
              break;
            default:
              break;
          }
          return newField;
        });
        break;

      // 5️⃣ Signature
      case "Signature":
        updatedSection.fields = section.fields.map((field, value) => {
          const newField = { ...field };
          // if (field.type === "recipientSignature") {
          //   newField.value = `${expertMember.user.firstName || ""} ${expertMember.user.lastName || ""}`.trim();
          // } else if (field.type === "expertSignature" && expertMember) {
          //   newField.value = `${createdBy.firstName || ""} ${createdBy.lastName || ""}`.trim();
          // }
          // console.log("conversationMembers",conversationMembers)
          // newField.value = `${conversationMembers[value].user.firstName || ""} ${conversationMembers[value].user.lastName || ""}`.trim();
          switch (field.selectedDropdownValue) {
            case "admin.name":
              newField.value = admin.firstName + " " + admin.lastName || "";
              break;
            case "createdBy.name":
              newField.value = createdBy.firstName +" "+ createdBy.lastName || "";
              break;
            default:
              break;
          }
          return newField;
        });
        break;

      // 🖼️ Add images to Photos section
      case "Photos":
        console.log("photoFilesphotoFiles", photoFiles)
        updatedSection.fields = section.fields.map((field) => {
          if (field.type === "arrayOfImages") {
            const updatedImages = photoFiles.map((file, idx) => {
              const existingText = field.value[idx]?.text || "";

              return {
                url: file.message.url ?? file.message,
                text: existingText // or use file.caption or label if available
              }
            });

            // Ensure the array has at least 3 items (as in template)
            while (updatedImages.length < field.value.length) {
              updatedImages.push({ url: "", text: field.value[updatedImages.length]?.text || "" });
            }

            return {
              ...field,
              value: updatedImages
            };
          }
          return field;
        });
        break;

      case "Attachments":
        updatedSection.fields = section.fields.map((field) => {
          if (field.type === "ArrayOfAttachments") {
            console.log("attachmentFiles", attachmentFiles)
            const updatedImages = attachmentFiles.map((file) => (file));

            // Ensure the array has at least 3 items (as in template)
            // while (updatedImages.length < field.value.length) {
            //   updatedImages.push({});
            // }

            return {
              ...field,
              value: updatedImages
            };
          }
          return field;
        });
        break;

      // 6️⃣ Photos & others → Leave as is
      default:
        break;
    }
    console.log("updatedSection", updatedSection)
    return updatedSection;
  });
  console.log("after populate template", populatedTemplate)
  return populatedTemplate;
}

const singleDefaultElementTypes = {
  ArrayOfImages: {
    type: "arrayOfImages",
    name: "Company Logos",
    value: ["", "", ""]
  },
  ArrayOfAttachments: {
    type: "ArrayOfAttachments",
    name: "Attachments",
    value: ["", "", ""]
  },
  singleDropdown: {
    type: "text",
    label: "",
    placeholder: "",
    selectedDropdownValue: "",
    value: "",
    isDigital: "digital",
  },
  singleFreeText: {
    type: "text",
    label: "",
    placeholder: "",
    selectedDropdownValue: "",
    value: "",
    isDigital: "field",
  },
  title: {
    label: ""
  }
}

const SortableItem = ({ section, isCreateReportRoute, sectionSchema }) => {
  console.log('vishhh', sectionSchema)
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: section.id }); // use id, not name

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };
  console.log('this is home section title------------------------>', section);

  return (
    <li
      ref={setNodeRef}
      key={section.id} // unique key
      style={style}
      {...attributes}
      {...listeners}
    >
      <Link
        to={`#${section?.id}`}
        className="template-section-item"
          onClick={() => {
          if(!isCreateReportRoute) return
          const el = document.getElementById(section.id);
          if (el) {
            el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }}
      >
        {!isCreateReportRoute && <Image src="/images/dragger-icon.svg" width={24} height={24} alt="Dragger Icon" />}
        <div className="template-section-item-button">
          {section?.icon ?? sectionSchema?.icon ?? ""}
          {section.name}
        </div>
      </Link>
    </li>
    // <li ref={setNodeRef} style={style} {...attributes} {...listeners}>
    //   <button
    //     type="button"
    //     className="template-section-item"
    //     onClick={() => {
    //       const el = document.getElementById(section.id);
    //       if (el) {
    //         el.scrollIntoView({
    //           behavior: "smooth",
    //           block: "start",
    //         });
    //       }
    //     }}
    //   >
    //     {!isCreateReportRoute && (
    //       <Image
    //         src="/images/dragger-icon.svg"
    //         width={24}
    //         height={24}
    //         alt="Dragger Icon"
    //       />
    //     )}
    //     <div className="template-section-item-button">
    //       {section.icon}
    //       {section.name}
    //     </div>
    //   </button>
    // </li>

  );
};

const DigitalTemplate = () => {
  const { templateId, conversationId, reportId } = useParams();
  const [editingSections, setEditingSections] = useState(() => new Set());
  const [addSection, setAddSection] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [templateJson, setTemplateJson] = useState();
  const [templateJsonClone, setTemplateJsonClone] = useState();
  const [templateType, setTemplateType] = useState();

  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");
  const { showAlert } = useAlert();
  const [isQuickPreviewDisabled] = useAtom(disableQuickPreviewAtom);
  const navigate = useNavigate();
  const location = useLocation();
  const [filesPagination, setFilesPagination] = useState({
    limit: 10,
    nextToken: null,
  });
  const isCreateReportRoute = /\/report-hub\/(create|edit)(\/|$)/.test(location.pathname);
  const [conversationData, setConversationData] = useState({});
  const [removeQuickPreview, setRemoveQuickPreview] = useState(false);


  const markSectionEditing = useCallback((sectionId, isEditing) => {
    setEditingSections(prev => {
      const next = new Set(prev);
      if (isEditing) {
        next.add(sectionId);
      } else {
        next.delete(sectionId);
      }
      return next;
    });
  }, []);


  useEffect(() => {
    // Hide Quick Preview when editing or viewing a digital/field template
    if (/\/report-hub\/digital-template\//.test(location.pathname) || /\/report-hub\/field-template\//.test(location.pathname)) {
      setRemoveQuickPreview(true);
    } else {
      setRemoveQuickPreview(false);
    }
  }, [location.pathname]);

  const handleSectionNameChange = (sectionId, newName) => {
    // update the section name inside templateJson.schema
    setTemplateJson((prev) => {
      if (!prev) return prev;
      const updated = { ...prev };
      updated.schema = (updated.schema || []).map((s) =>
        s.id === sectionId ? { ...s, name: newName } : s
      );
      return updated;
    });
  };

  const buildImageListPayloadCreate = (templateJson) => {
    const linearArray = [];

    if (!templateJson?.schema) return linearArray;
    templateJson.schema.forEach((section) => {
      if (section?.tag == "CompanyDetails") {
        section.fields?.forEach((field) => {

          // arrayOfImages type
          if (field.type === "arrayOfImages") {
            field.value.forEach((val) => {
              if (typeof val === "string" && val.trim().length > 0) {
                linearArray.push(val); // existing URL
              } else if (val?.url) {
                linearArray.push(val?.url); // preview from uploaded
              } else if (val?.file) {
                linearArray.push(val?.file?.name || ""); // fallback, optional
              } else {
                linearArray.push("");
              }

            });
          }

        });
      }

    });
    return JSON.stringify(linearArray);
  };

  const buildReportAttachments = (templateJson) => {
    const linearArray = [];

    if (!templateJson?.schema) return linearArray;
    templateJson.schema.forEach((section) => {
      if (section?.tag == "CompanyDetails") {
        section.fields?.forEach((field) => {

          // arrayOfImages type
          if (field.type === "arrayOfImages") {
            field.value.forEach((val) => {
              if (typeof val === "string" && val.trim().length > 0) {
                linearArray.push(val); // existing URL
              } else if (val?.url) {
                linearArray.push(val?.url); // preview from uploaded
              } else if (val?.file) {
                linearArray.push(val?.file?.name || ""); // fallback, optional
              } else {
                linearArray.push(null);
              }

            });
          }

        });
      }

    });
    return JSON.stringify(linearArray);
  };


  const downloadFile = async () => {

    const blob = await pdf(<ReportPDF data={templateJson} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "example.pdf";
    link.click();

  }

  const handleSavePublish = async () => {
    try {
      const formData = new FormData();

      const cloned = structuredClone(templateJson);
      formData.append("templateType", cloned.templateType || "digital");
      formData.append("name", cloned.name || "digital");


      cloned.schema.forEach((section, secIdx) => {
        section.fields.forEach((field, fieldIdx) => {
          if (field.type === "arrayOfImages") {
            field.value.forEach((val, imgIdx) => {
              if (val?.file) {
                // 👉 flat append: just `images[]`
                formData.append("images", val.file);
                // 👉 keep only preview url in JSON
                field.value[imgIdx] = "";
              }
            });
          }
        });
      });


      // 3. Add schema (stringified, but without replacing file objects)
      //    You may want to store file placeholders instead of File object
      const schemaForApi = cloned.schema.map((s) => {
        return {
          ...s,
          fields: s.fields?.map((f) => {

            return f;
          }),
        };
      });

      formData.append("schema", JSON.stringify(schemaForApi));
      let response;
      try {
        if (!templateJson.name) {
          setError(`Template name is required.`);
          return;
        }
        if (templateJson.name.length > 50) {
          setError(`Template name cannot exceed 50 characters.`);
          return;
        } else {
          setError("");
        }

        if (cloned?.id == null) {


          formData.append("imageList", buildImageListPayloadCreate(templateJson)); // JSON string of linear array
          // for (const [name, value] of formData.entries()) {
          //     console.log(`${name}: ${value}`);
          // }
          // return;

          if (isSaving) return;
          setIsSaving(true);
          response = await createTemplate(formData);
          navigate(response?.data?.id, { replace: true });
          setIsSaving(false);
        } else {
          // const linearMedia = buildLinearMediaPayload(templateJson);
          // formData.append("imageList", JSON.stringify(linearMedia));

          // formData.append("imageList", buildImagesPayload(templateJson)); // JSON string of linear array

          formData.append("imageList", buildImageListPayloadCreate(templateJson)); // JSON string of linear array
          // console.log("asdasd", buildImagesPayload(templateJson), JSON.stringify(schemaForApi))
          // return;
          response = await updateTemplate(cloned?.id, formData);
        }

        navigate("/report-hub");
        showAlert({
          title: "Template Notification",
          message: response?.message ?? "something went wrong",
          variant: "success",
        });
      } catch (error) {
        console.error("Error saving user:", error);
        setIsSaving(false);
        showAlert({
          title: "Template Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });

      }

      // // 4. Send request
      // const response = await fetch("/api/templates", {
      //   method: "POST",
      //   body: formData,
      // });



      console.log("Template saved:", response);
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const resetFormData = () => {
    setTemplateJson({ ...templateJsonClone })
  }

  const buildLinearMediaPayload = (templateJson) => {
    const linearArray = [];

    if (!templateJson?.schema) return linearArray;

    templateJson.schema.forEach((section) => {
      if (section?.tag != "CompanyDetails") {
        section.fields?.forEach((field) => {

          // arrayOfImages type
          if (field.type === "arrayOfImages") {
            field.value.forEach((val) => {
              if (val) {
                if (typeof val === "string") {
                  linearArray.push(val); // existing URL
                } else if (val.url) {
                  linearArray.push(val.url); // preview from uploaded
                } else if (val.file) {
                  linearArray.push(val.file.name || ""); // fallback, optional
                }
              }
            });
          }

        
        });
      }

    });

    return linearArray;
  };

  const buildLinearMediaPayloadAttachment = (templateJson) => {
    const linearArray = [];

    if (!templateJson?.schema) return linearArray;

    templateJson.schema.forEach((section) => {
      if (section.tag == "Attachments" ) {
        section.fields?.forEach((field) => {

          // arrayOfImages type
          if (field.type === "ArrayOfAttachments") {
            field.value.forEach((val) => {
              if (val) {
                if (typeof val === "string") {
                  linearArray.push(val); // existing URL
                } else if (val.url) {
                  linearArray.push(val.url); // preview from uploaded
                } else if (val.message) {
                  linearArray.push(val.message); // preview from uploaded
                } else if (val.file) {
                  linearArray.push(val.file.name || ""); // fallback, optional
                }
              }
            });
          }

        
        });
      }

    });

    return linearArray;
  };


  const handleSavePublishReport = async () => {
    try {
      const formData = new FormData();

      // 1. Add simple string values

      // clone templateJson safely

      console.log("val.file", templateJson);
      // const cloned = JSON.parse(JSON.stringify(templateJson));


      const cloned = structuredClone(templateJson);
      formData.append("templateType", cloned.templateType || "digital");
      formData.append("template", templateId || "");
      formData.append("conversationId", conversationId || "");

      formData.append("name", cloned.name || "digital");


      cloned.schema.forEach((section, secIdx) => {
        section.fields.forEach((field, fieldIdx) => {
          if (section.tag != "CompanyDetails" && field.type === "arrayOfImages") {
            field.value.forEach((val, imgIdx) => {
              if (val?.file) {
                // 👉 flat append: just `images[]`
                formData.append("images", val.file);
                console.log("val.file", val)
                // 👉 keep only preview url in JSON
                field.value[imgIdx] = { url: val.preview, text: val.text };
              }
            });
          }
          if (section.tag == "Attachments" && field.type === "ArrayOfAttachments") {
            console.log("val.attachments112", section.tag)
            field.value.forEach((val, imgIdx) => {
              console.log("val.attachments11", val)
              if (val?.file) {
                // 👉 flat append: just `images[]`
                formData.append("attachments", val.file);
                console.log("val.attachments", val)
                // 👉 keep only preview url in JSON
                field.value[imgIdx] = { url: val.preview };
              }
            });
          }
        });
      });


      // 3. Add schema (stringified, but without replacing file objects)
      //    You may want to store file placeholders instead of File object
      const schemaForApi = cloned.schema.map((s) => {
        return {
          ...s,
          fields: s.fields?.map((f) => {
            return f;
          }),
        };
      });

      formData.append("schema", JSON.stringify(schemaForApi));

      console.log("asdasd", schemaForApi);

      // if (cloned?.id == null) {
      //     response = await createTemplate(formData);
      //     navigate(response?.data?.id, { replace: true });
      //   } else {
      //     formData.append("imageList", buildImagesPayload(templateJson)); // JSON string of linear array

      //     response = await updateTemplate(cloned?.id, formData);
      //   }


      // return ;
      let response;
      try {

        if (reportId == null) {

          const linearMedia = buildLinearMediaPayload(templateJson);
          formData.append("imageList", JSON.stringify(linearMedia));

          const linearMediaAttachment = buildLinearMediaPayloadAttachment(templateJson);
          formData.append("attachmentList", JSON.stringify(linearMediaAttachment));

          // for (let [key, value] of formData.entries()) {
          //   console.log(`${key}: ${value}`);
          // }
          // return;

          response = await createReport(formData);
          navigate("/report-hub/list");
        } else {
          const linearMedia = buildLinearMediaPayload(templateJson);
          formData.append("imageList", JSON.stringify(linearMedia));

          const linearMediaAttachment = buildLinearMediaPayloadAttachment(templateJson);
          formData.append("attachmentList", JSON.stringify(linearMediaAttachment));

          response = await updateReport(cloned?.id, formData);
        }


        showAlert({
          title: "Report Notification",
          message: response?.message ?? "something went wrong",
          variant: "success",
        });
        navigate("/report-hub/list");
      } catch (error) {
        console.error("Error saving user:", error);
        showAlert({
          title: "Template Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }

      // // 4. Send request
      // const response = await fetch("/api/templates", {
      //   method: "POST",
      //   body: formData,
      // });



      console.log("Template saved:", response);
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const updateTemplateName = (name) => {
    setTemplateJson({ ...templateJson, "name": name })
  }

  const BeadcrumbItems = [
    { label: "Report Hub", href: "/report-hub" },
    { label: "Create Template", active: true },
  ];
  console.log("templateType-----------------------------", templateType);
  // sectionDropdowns.js
  const sectionDropdowns = {
    "CompanyDetails": [
      // { key: "name", label: templateType === 'Digital' ? "Participant 1 Name" : "Participant 1 name" },
      // { key: "companyName", label: templateType === 'Digital' ? "Participant 1 Company" : "Participant 1 company" },
      // { key: "address", label: templateType === 'Digital' ? "Participant 1 Address" : "Participant 1 address" },
      // { key: "city", label: templateType === 'Digital' ? "Participant 1 City" : "Participant 1 city" },
      // { key: "state", label: templateType === 'Digital' ? "Participant 1 State" : "Participant 1 state" },
      // { key: "zipCode", label: templateType === 'Digital' ? "Participant 1 Zip Code" : "Participant 1 zip code" },
      // { key: "country", label: templateType === 'Digital' ? "Participant 1 Country" : "Participant 1 country" },
      // { key: "phoneNumber", label: templateType === 'Digital' ? "Participant 1 Phone" : "Participant 1 phone" },
      // { key: "email", label: templateType === 'Digital' ? "Participant 1 Email" : "Participant 1 email" },
      { key: "admin.name", label: templateType === 'Digital' ? "Participant 1 Name" : "Participant 1 name" },
      { key: "admin.company", label: templateType === 'Digital' ? "Participant 1 Company" : "Participant 1 company" },
      { key: "admin.address", label: templateType === 'Digital' ? "Participant 1 Address" : "Participant 1 address" },
      { key: "admin.city", label: templateType === 'Digital' ? "Participant 1 City" : "Participant 1 city" },
      { key: "admin.state", label: templateType === 'Digital' ? "Participant 1 State" : "Participant 1 state" },
      { key: "admin.zipCode", label: templateType === 'Digital' ? "Participant 1 Zip Code" : "Participant 1 zip code" },
      { key: "admin.country", label: templateType === 'Digital' ? "Participant 1 Country" : "Participant 1 country" },
      { key: "admin.phoneNumber", label: templateType === 'Digital' ? "Participant 1 Phone" : "Participant 1 phone" },
      { key: "admin.email", label: templateType === 'Digital' ? "Participant 1 Email" : "Participant 1 email" },
      { key: "createdBy.address", label: "Participant 2 Address" },
      { key: "createdBy.company", label: "Participant 2 Company" },
      { key: "createdBy.city", label: "Participant 2 City" },
      { key: "createdBy.state", label: "Participant 2 State" },
      { key: "createdBy.zipCode", label: "Participant 2 Zip Code" },
      { key: "createdBy.country", label: "Participant 2 Country" },
      { key: "createdBy.phoneNumber", label: "Participant 2 Phone" },
      { key: "createdBy.email", label: "Participant 2 Email" },
      { key: "createdBy.name", label: "Participant 2 Name" }
    ],
    "Signature": [
      { key: "admin.name", label: templateType === 'Digital' ? "Participant 1 Name " : "Participant 1 name " },
      { key: "createdBy.name", label: "Participant 2 Name" }
    ],
    "ClientDetails": [
      // { key: "name", label: "Name" },
      { key: "address", label: "Participant 2 Address" },
      { key: "company", label: "Participant 2 Company" },
      { key: "city", label: "Participant 2 City" },
      { key: "state", label: "Participant 2 State" },
      { key: "zipCode", label: "Participant 2 Zip Code" },
      { key: "country", label: "Participant 2 Country" },
      { key: "phoneNumber", label: "Participant 2 Phone" },
      { key: "email", label: "Participant 2 Email" },
      { key: "participantName", label: "Participant 2 Name" }
    ],

    "ExpertiseDetails": [
      { key: "expertiseName", label: "Name of Expertise" },
      { key: "subExpertiseName", label: "Name of Sub Expertise" },
    ],

    "SessionDetails": [
      { key: "startDate", label: "Start Date" },
      { key: "startTime", label: "Start Time" },
      { key: "endDate", label: "End Date" },
      { key: "endTime", label: "End Time" },
      { key: "duration", label: "Total Session Duration" },
      { key: "admin.name", label: "Participant 1 Name" },
      { key: "createdBy.name", label: "Participant 2 Name" }
    ],
  };


  const sectionComponents = {
    // "CompanyDetails": (props) => (
    //   <CompanySection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} dropdownOptions={sectionDropdowns["CompanyDetails"]} {...props} />
    // ),
    CompanyDetails: CompanySection,
    Title: TitleSection,
    ClientDetails: CompanySection,
    ExpertiseDetails: CompanySection,
    Photos: PhotoSection,
    Notes: NotesSection,
    SessionDetails: CompanySection,
    Signature: SignatureSection,
    Attachments: AttachmentsSection,
    Subtitle: TitleSection

    // "Title": (props) => (
    //   <TitleSection singleDefaultElementTypes={singleDefaultElementTypes} handleSectionNameChange={handleSectionNameChange} updateStateInformation={updateStateInformation} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} />
    // ),
    // "ClientDetails": (props) => (
    //   <CompanySection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} dropdownOptions={sectionDropdowns["ClientDetails"]} {...props} />
    // ),
    // "ExpertiseDetails": (props) => (
    //   <CompanySection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} dropdownOptions={sectionDropdowns["ExpertiseDetails"]}
    //     {...props} />
    // ),
    // "Photos": (props) => (
    //   <PhotoSection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} />
    // ),
    // "Notes": (props) => (
    //   <NotesSection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} />
    // ),
    // "SessionDetails": (props) => (
    //   <CompanySection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} dropdownOptions={sectionDropdowns["SessionDetails"]} {...props} />
    // ),
    // "Signature": (props) => (
    //   <SignatureSection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} dropdownOptions={sectionDropdowns["Signature"]} />
    // ),
    // "Attachments": (props) => (
    //   <AttachmentsSection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} />
    // ),
    // "Subtitle": (props) => (
    //   <TitleSection singleDefaultElementTypes={singleDefaultElementTypes} conversationData={conversationData} isCreateReportRoute={isCreateReportRoute} {...props} />
    // ), // temporary reuse
  };


  const templateSections = [
    {
      icon: <UserListIcon />,
      name: "Participant Details",
      tag: "CompanyDetails",
      object: "createdBy",
      show: true
      // schema: HeaderSchema
    },
    {
      icon: <TextTIcon />,
      name: "Title",
      tag: "Title",
      object: "",
      show: true,
      schema: TitleSchema
    },
    {
      icon: <UserListIcon />,
      name: "Client Details",
      tag: "ClientDetails",
      show: false
      // schema: ClientDetailSchema
    },
    {
      icon: <UserCircleGearIcon />,
      name: "Expertise Details",
      tag: "ExpertiseDetails",
      show: true
      // object: "expertise"
      // schema: ExpertiseDetailsSchema
    },
    {
      icon: <ImageIcon />,
      name: "Photos",
      tag: "Photos",
      object: "",
      schema: PhotoSectionSchema,
      show: true
    },
    {
      icon: <NotePencilIcon />,
      name: "Notes",
      tag: "Notes",
      object: "",
      schema: NotesSchema,
      show: true
    },
    {
      icon: <ClockCountdownIcon />,
      name: "Session Details",
      tag: "SessionDetails",
      object: "",
      show: true
      // schema: SessionDetailsSchema
    },
    {
      icon: <SignatureIcon />,
      name: "Signature",
      tag: "Signature",
      object: "",
      show: true,
      schema: SignatureSchema
    },
    {
      icon: <LinkIcon />,
      name: "Attachments",
      tag: "Attachments",
      object: "",
      schema: AttachmentsSectionSchema,
      show: true
    },
    // {
    //   icon: <TextAaIcon />,
    //   name: "Subtitle",
    //   schema: TitleSchema
    // },
  ];




  const getReportInformationById = async (reportId) => {

    try {

      const response = await getReportById(reportId);
      if (response?.data?.id) {
        setTemplateJson((psetTemplateImagesrev) => { return response?.data })
        // setTemplateImages((prev) => { return response?.data?.images })
        setTemplateJsonClone(((prev) => { return response?.data }));
        return response?.data
      } else {
        showAlert({
          title: "Template Notification",
          message: response?.message ?? "something went wrong",
          variant: "danger",
        });
      }

    } catch (error) {
      showAlert({
        title: "Template Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  }



  const getTemplateInformation = async (tempalteId) => {

    try {

      const response = await getTemplateById(tempalteId);
      if (response?.data?.id) {
        setTemplateJson((prev) => { return response?.data })
        setTemplateJsonClone(((prev) => { return response?.data }));
        // setTemplateImages((prev) => { return response?.data?.images })
        return response?.data;
      } else {
        showAlert({
          title: "Template Notification",
          message: response?.message ?? "something went wrong",
          variant: "danger",
        });
      }

    } catch (error) {
      showAlert({
        title: "Template Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  }

  const getConversationDetailData = async () => {
    try {
      const data = await getConversationDetail(conversationId);
      console.log("data?.data", data?.data)
      setConversationData(data?.data)

      return data?.data;
      // const anotherMemberData = data?.data?.conversationMembers?.find((e) => e.user_id != auth?.user?.id);
      // const myMemberData = data?.data?.conversationMembers?.find((e) => e.user_id != data?.data?.createdBy?.id);
      // setAnotherMember(anotherMemberData);
      // setMyMember(myMemberData);
      // console.log("myMemberData",myMemberData)
      // setTotalSessionDuration(() => getDurationBetween(data?.data?.endTime, data?.data?.startTime || data?.data?.createdAt));
      // setCallDurations(getTotalConversationDuration(data?.data?.calls || []));


    } catch (error) {
      console.error("Error fetching chat conversation:", error);
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };


  const getFiles = async (conversationId, next = null, accumulated = []) => {
    const data = await getChatFiles(conversationId, {
      ...filesPagination,
      nextToken: next || filesPagination.nextToken,
    });

    const newFiles = data?.data?.items || [];

    if (newFiles.length > 0) {
      newFiles.sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
    }

    const finalData = newFiles.map((element) => {
      const parts = element?.message.split("/");
      const filename = parts[parts.length - 1];
      return { ...element, name: filename };
    });

    const mappedTranscripts = [...new Set(data?.data?.transcripts || [])].map((url) => {
      console.log("urlurlurl", url?.url)
      const parts = url?.url?.split("/") || url?.split("/");
      const filename = parts[parts.length - 1];
      return {
        id: `transcript-${filename}`,
        message_type: 7,
        message: url?.url,
        name: filename,
        created_date: new Date().toISOString(),
      };
    });

    const mappedRecordings = [...new Set(data?.data?.recordings || [])].map((url) => {
      const parts = url?.url?.split("/") || url?.split("/");
      const filename = parts[parts.length - 2];
      return {
        id: `recording-${filename}`,
        message_type: 4,
        message: url,
        name: filename,
        created_date: new Date().toISOString(),
      };
    });

    const mappedScreenshots = [...new Set(data?.data?.screenshotImages || [])].map((url) => {
      const parts = url?.url?.split("/") || url?.split("/");
      const filename = parts[parts.length - 1];
      return {
        id: `screenshot-${filename}`,
        message_type: 3,
        message: url,
        name: filename,
        created_date: new Date().toISOString(),
      };
    });

    const combinedData = [...finalData, ...mappedTranscripts, ...mappedScreenshots, ...mappedRecordings];
    const updatedAccumulated = [...accumulated, ...combinedData];

    const nextToken = data?.data?.nextToken;

    if (nextToken) {
      return await getFiles(conversationId, nextToken, updatedAccumulated);
    } else {

      console.log("asdasdasdasdasdasd11", updatedAccumulated)
      return updatedAccumulated;
    }
  };


  useEffect(() => {


    if (location.pathname.includes("digital-template")) {
      setTemplateType('Digital');
      if (typeof templateId != "undefined") {

        getTemplateInformation(templateId)

      } else {
        setTemplateJson((prev) => { return { ...schemaDefaultObjectDigital } })
        setTemplateJsonClone(((prev) => { return { ...schemaDefaultObjectDigital } }));
        // setTemplateImages((prev) => { return { ...schemaDefaultObjectDigital.images } })
      }
    } else if (location.pathname.includes("field-template")) {
      setTemplateType('Field');
      if (typeof templateId != "undefined") {
        // alert(templateId)
        getTemplateInformation(templateId)

      } else {
        setTemplateJson((prev) => { return { ...schemaDefaultObjectField } })
        setTemplateJsonClone(((prev) => { return { ...schemaDefaultObjectField } }));
        // setTemplateImages((prev) => { return { ...schemaDefaultObjectField.images } })
      }
    } else if (/\/report-hub\/create(\/|$)/.test(location.pathname)) {
      if (typeof templateId != "undefined" && typeof conversationId != "undefined") {
        // getTemplateInformation(templateId);
        // getConversationDetailData();
        // getFiles(conversationId);
      }
    } else if (/\/report-hub\/edit(\/|$)/.test(location.pathname)) {
      if (typeof reportId != "undefined") {
        getReportInformationById(reportId);
        // adjustTemplateImagesArray()
        // getTemplateInformation(templateId);
        // getConversationDetailData();
        // getFiles(conversationId);
      }
    }
  }, [templateId])



  // useEffect(() => {
  //   if (templateJson && conversationData && chatFiles && !templateJson.__populated) {

  //     console.log("chatFiles", chatFiles)

  //     const populated = populateTemplate(templateJson, conversationData);
  //     populated.__populated = true; // prevent future loops
  //     console.log("populatedJson", populated)
  //     setTemplateJson(populated);
  //   }
  // }, [templateJson, conversationData, chatFiles]);

  useEffect(() => {
    const populateAfterData = async () => {
      if (templateId && conversationId) {
        const [templateRes, conversationRes, allChatFiles] = await Promise.all([
          getTemplateInformation(templateId),
          getConversationDetailData(),
          getFiles(conversationId)
        ]);

        if (templateRes && conversationRes) {
          const populated = populateTemplate(templateRes, conversationRes, allChatFiles);
          populated.__populated = true;
          setTemplateJson(populated);
        }
      } else if (templateId) {
        const templateRes = await getTemplateInformation(templateId);


        // setTemplateJson({...populated});
        // alert("got template")
        const populated = populateTemplate({ ...templateRes }, null, null);
        populated.__populated = true;
        setTemplateJson(populated);
      }
    };

    populateAfterData();
  }, [templateId, conversationId]);


  const [selectedSections, setSelectedSections] = useState([]);

  // Utility function
  function updateStateInformation(value, setState, stateName, index = null) {
    setState((prev) => {
      const prevValue = prev[stateName];

      // ✅ Case 1: If it's an array and index is given → update element
      if (Array.isArray(prevValue) && index !== null) {
        const updatedArray = [...prevValue];
        updatedArray[index] = value;
        return { ...prev, [stateName]: updatedArray };
      }

      // ✅ Case 2: If it's an object → update by key
      if (typeof prevValue === "object" && prevValue !== null && !Array.isArray(prevValue)) {
        return {
          ...prev,
          [stateName]: {
            ...prevValue,
            ...value, // expects { key: newValue }
          },
        };
      }

      // ✅ Case 3: Direct value update

      console.log("state update", { ...prev, [stateName]: value })
      return { ...prev, [stateName]: value };
    });
  }

  useEffect(() => {
    if (templateJson?.images?.length > 0) {
      setTemplateJson((prev) => {
        const updated = { ...prev };
        updated.schema = updated.schema.map((section) => {
          if (section.fields) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (isCreateReportRoute && reportId) {
                  
                  // if(reportId){
                    if (field.type === "arrayOfImages" && field.name === "Photos") {
                      // alert("create report")
                      // console.log('fields in edit report old', { field })
                      // console.log('fields in edit report', { ...field, value: templateJson.images })
                      // return { ...field, value: templateJson.images };

                      // ------------------------

                      
                        const updatedImages = templateJson.images.map((file, idx) => {
                          const existingText = field.value[idx]?.text || "";

                          return {
                            url: file.replaceAll("/staging-vyzeo", ""),
                            text: existingText // or use file.caption or label if available
                          }
                        });

                        // Ensure the array has at least 3 items (as in template)
                        while (updatedImages.length < field.value.length) {
                          updatedImages.push({ url: "", text: field.value[updatedImages.length]?.text || "" });
                        }

                        return {
                          ...field,
                          value: updatedImages
                        };
                      
                      return field;
                    }
                  // }
                  // if (field.type === "arrayOfImages" && field.name === "Company Logos") {
                  //   return { ...field, value: templateJson.images };
                  // }
                  if (field.type === "ArrayOfAttachments" && field.name === "Attachments") {
                    // alert("asd")

                    const updatedAttachments = templateJson.attachments.map((file, idx) => {
                         
                      return {
                        message: file.replaceAll("/staging-vyzeo", ""),
                      }
                    });

                    return {
                      ...field,
                      value: updatedAttachments
                    };
                  }
                } else {
                  if (field.type === "arrayOfImages" && field.name === "Company Logos") {
                    return { ...field, value: templateJson.images };
                  }
                }
                
                return field;
              }),
            };
          }
          return section;
        });
        return updated;
      });
    }
  }, [templateJson?.images]);

  // useEffect(() => {
  //     updateStateInformation(templateName, setTemplateJson, "name");
  //  }, [templateName]);

  console.log("udpate json", templateJson)
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return; // guard

    if (active.id !== over.id) {
      setTemplateJson((prev) => {
        const oldIndex = prev.schema.findIndex((item) => item.id === active.id);
        const newIndex = prev.schema.findIndex((item) => item.id === over.id);

        return {
          ...prev,
          schema: arrayMove(prev.schema, oldIndex, newIndex),
        };
      });
    }
  };


  const nameInputRef = useRef(null);

  // 👇 Auto-scroll to error field when error appears
  useEffect(() => {
    if (error && nameInputRef.current) {
      nameInputRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      nameInputRef.current.focus(); // also focuses the field
    }
  }, [error]);

  const updateSection = useCallback((sectionId, updater) => {
    setTemplateJson(prev => {
      // DELETE
      if (updater === null) {
        return {
          ...prev,
          schema: prev.schema.filter(section => section.id !== sectionId),
        };
      }

      // UPDATE
      return {
        ...prev,
        schema: prev.schema.map(section =>
          section.id === sectionId ? updater(section) : section
        ),
      };
    });
  }, []);



  console.log("sections updated", templateType, templateJson?.templateType);
  return (
    <>
      <Row className="align-items-end justify-content-between gy-3 gy-xl-0 mb-4">
        <Col xl="7">
          {!isCreateReportRoute && <CustomBreadcrumb items={BeadcrumbItems} />}
          {!isCreateReportRoute ? (
            <PageTitle
              title={`${(typeof templateId === 'undefined')?"Create":"Edit"} - ${templateJson?.templateType == "digital" ? "Session" : "Field"
                } Template`}
            />
          ) : (
            <PageTitle
              title={`${(typeof reportId === 'undefined')?"Create":"Edit"} - ${templateJson?.templateType == "digital" ? "Session" : "Field"
                } Report`}
            />
          )}
        </Col>
        <Col xl="5" className="text-end">
          {(templateJson?.schema?.length > 0) && <div className="d-flex flex-wrap align-items-center justify-content-xl-end gap-2">
            <Button
              as="button"
              variant="white"
              className="btn-md d-inline-flex align-items-center gap-1"
              onClick={() => {
                navigate(-1)
                
              }}
            >

              Cancel
            </Button>

            <Button
              as="button"
              disabled={isQuickPreviewDisabled}
              variant="white"
              className="border-white btn-md d-inline-flex align-items-center gap-1"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <LightningIcon />
              Preview {(!isCreateReportRoute)?"Template":"Report"}
            </Button>

            {!removeQuickPreview && (
              <Button
                as="button"
                variant="white"
                className="btn-md d-inline-flex align-items-center gap-1"
                onClick={() => downloadFile()}
              >
                <LightningIcon />
                Quick Preview1
              </Button>
            )}

            {!isCreateReportRoute && (
              <Button
                as="button"
                variant="primary"
                className="btn-md d-inline-flex align-items-center gap-1"
                onClick={handleSavePublish}
                disabled={(editingSections.size > 0)} // disable while saving
              >
                {isSaving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Saving...
                  </>
                ) : (
                  <>
                    <SaveIcon />
                    Save & Publish
                  </>
                )}
              </Button>
            )}

            {isCreateReportRoute && <Button
              as="button"
              variant="primary"
              className="btn-md d-inline-flex align-items-center gap-1"
              onClick={handleSavePublishReport}
              disabled={(editingSections.size > 0)}
            >
              <SaveIcon />
              Save & Update
            </Button>}
          </div>}
        </Col>
      </Row>
      <Row className="gy-4 gy-xl-0">
        <Col xl="3">
          <CardWrapper className="full-box-0 full-box-xl-auto">
            {/* Left Sidebar */}
            {/* {templateJson?.schema?.length > 0 && <DndContext onDragEnd={handleDragEnd}>
              <SortableContext
                // disabled={isCreateReportRoute}
                items={templateJson?.schema?.map((s) => s.id)} // use id
                strategy={verticalListSortingStrategy}
              >
                <ul className="d-flex flex-column gap-2 list-unstyled mb-0">
                  {templateJson?.schema?.map((section, order) => (
                    <SortableItem isCreateReportRoute={isCreateReportRoute} section={section} key={section?.id} />
                  ))}
                </ul>
              </SortableContext>
            </DndContext>} */}
            {templateJson?.schema?.length > 0 && (
              isCreateReportRoute ? (
                <ul className="d-flex flex-column gap-2 list-unstyled mb-0">
                  {templateJson.schema.map((section) => {
                    const sectionObj = templateSections.find((s) => s.tag === section.tag);
                    return <SortableItem
                      key={section.id}
                      section={section}
                      sectionSchema={sectionObj}
                      isCreateReportRoute
                    />;
                  }
                    
                  )}
                </ul>
              ) : (
                <DndContext onDragEnd={handleDragEnd}>
                  <SortableContext
                    items={templateJson.schema.map((s) => s.id)}
                    strategy={verticalListSortingStrategy}
                  >
                    <ul className="d-flex flex-column gap-2 list-unstyled mb-0">
                      {templateJson.schema.map((section) => {
                        const sectionObj = templateSections.find((s) => s.tag === section.tag);
                        console.log("section.tag",section.tag)
                        return <SortableItem
                          key={section.id}
                          sectionSchema={sectionObj}
                          section={section}
                          isCreateReportRoute={false}
                        />
                      })}
                    </ul>
                  </SortableContext>
                </DndContext>
              )
            )}

            {console.log('this is home page data ------------------>', templateJson)}
            {!isCreateReportRoute && <Button
              variant="dashed-primary"
              className="btn-md w-100 d-flex align-items-center justify-content-center gap-1 mt-4"
              onClick={() => setAddSection(true)}
            >
              <PlusIcon />
              New Section
            </Button>}
            {addSection && (
              <div className="add-section-modal">
                <div className="add-section-modal-header">
                  <h2>Select New Sections</h2>
                  <button
                    type="button"
                    className="modal-close"
                    onClick={() => setAddSection(false)}
                  >
                    <XIcon size="16" />
                  </button>
                </div>
                <div className="add-section-modal-body">
                  <Row className="g-3">
                    {templateSections.filter((e)=>e.show === true)
                      // remove sections which are already exist in template
                      // .filter(
                      //   (section) =>
                      //     !templateJson?.schema.some((s) => s.name === section.name)
                      // )
                      .map((section, idx) => (
                        <Col md="4" className="add-section-item" key={section.tag}>
                          <input
                            type="checkbox"
                            name="add-section"
                            id={`section-${idx}`}
                            checked={selectedSections.includes(section.tag)}
                            onChange={(e) => {
                              console.log("selectedSectionsChange", section)
                              if (e.target.checked) {
                                setSelectedSections((prev) => [...prev, section.tag]);
                              } else {
                                setSelectedSections((prev) =>
                                  prev.filter((label) => label !== section.tag)
                                );
                              }
                              
                            }}
                          />
                          {console.log("selectedSections", selectedSections)}
                          <label
                            className="add-section-item-label"
                            htmlFor={`section-${idx}`}
                          >
                            {section.icon}
                            <p className="fs-14 fw-500 mt-2 mb-0">{section.name}</p>
                          </label>
                        </Col>
                      ))}

                  </Row>
                </div>
                <div className="add-section-modal-footer">
                  <Button
                    variant="primary"
                    className="btn-md"
                    onClick={() => {
                      setTemplateJson((prev) => ({
                        ...prev,
                        schema: [
                          ...prev.schema,
                          ...selectedSections.map((tag) => {
                            const sectionObj = templateSections.find((s) => s.tag === tag);

                            return {
                              id: uuidv4(),
                              name: sectionObj?.name,        // must match sectionComponents key
                              tag: sectionObj?.tag,         // optional, can be same
                              fields: sectionObj?.schema?.fields ?? [], // ensure fields exists
                            };
                          }),
                        ],
                      }));


                      setAddSection(false);
                      setSelectedSections([]); // reset
                    }}
                  >
                    Add Section
                  </Button>

                  <Button
                    variant="outline-secondary"
                    className="btn-md"
                    onClick={() => setAddSection(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </CardWrapper>
        </Col>
        <Col xl="9">
          <div className="template-section-body overflow-auto full-box-0 full-box-xl-auto pe-2">
            {!isCreateReportRoute && (
              <div className="hover-input-group">
                <Form.Group controlId="templateName" className="w-100">
                  <div className="d-flex flex-column">
                    <Form.Control
                      type="text"
                      ref={nameInputRef}
                      onChange={(e) => {
                        setTemplateJson({ ...templateJson, "name": e.target.value })
                      }
                      }
                      name="template-name"
                      value={templateJson?.name}
                      className="form-control form-control-lg fw-bold"
                      placeholder="Name This Template"
                      isInvalid={!!error}
                    />
                    {error && (
                      <Form.Control.Feedback
                        type="invalid"
                        className="d-block mt-1 text-start"
                      >
                        {error}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Form.Group>
              </div>
            )}

            {templateJson?.schema?.length > 0 && (

              <AnimatePresence initial={false}>
                {templateJson?.schema?.map((section, index) => {
                  const Component = sectionComponents[section.tag];
                  if (!Component) return null;

                  return (
                    <motion.div
                      id={section.id}
                      key={section.id}
                      layout
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 35,
                        duration: 0.4,
                      }}
                    >
                      <div className="bg-white rounded-3 w-100 mt-3">
                        <Component
                          markSectionEditing={markSectionEditing}
                          templateId={templateJson?.id}
                          templplateType={templateJson?.templateType}
                          updateSection={updateSection}
                          section={section}
                          singleDefaultElementTypes={singleDefaultElementTypes}
                          conversationData={conversationData}
                          isCreateReportRoute={isCreateReportRoute}
                          dropdownOptions={sectionDropdowns[section.tag]}
                          handleSectionNameChange={handleSectionNameChange}
                          updateStateInformation={updateStateInformation}
                          updateTemplateName={updateTemplateName}
                        />
                      </div>
                    </motion.div>
                  );
                })}
              </AnimatePresence>
            )}
          </div>

        </Col>
      </Row >

      {/* Quick Preview Modal */}
      < Modal
        className="quick-preview-modal"
        show={!!showModal
        }
        onHide={() => setShowModal(false)}
        centered
        size="xl"
      >
        <Modal.Header className="p-4 border-0 pb-0" closeButton>
          <Modal.Title className="fs-20 fw-semibold text-gray-700">
            Template Preview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {/* <PDFViewer height="900px" style={{ width: "100%", height: "100%" }}>
          <ReportPDF data={templateJson} />
        </PDFViewer> */}
          <ReportPreview data={templateJson} />
            {/* <PDFViewer><ReportPDF data={templateJson} /></PDFViewer> */}

        </Modal.Body>
      </Modal >
      {/* Quick Preview Modal */}
    </>
  );
};

export default DigitalTemplate;
